/**
 * Web Locks steal-arbitration detection, shared by the global error toast
 * bridge (useGlobalErrorHandler) and useAuth's multi-tab handling. Keep the
 * two match phrases in sync with src/lib/sentry.ts, which drops the same
 * events before they reach Sentry (CR-DASHBOARD-3K/3J).
 *
 * supabase-js serializes auth token refresh through navigator.locks. When a
 * second tab preempts the held lock, the WAITER rejects with "Lock was stolen
 * by another request" and the HOLDER with 'Lock "lock:sb-...-auth-token" was
 * released because another request stole it'. Both are benign multi-tab
 * contention - self-healing, never a bug - and must never surface to the user
 * as a raw browser error.
 */
export function isLockStealMessage(message: unknown): boolean {
  const m = String(message ?? "").toLowerCase();
  return m.includes("lock was stolen") || m.includes("another request stole it");
}

export function isLockStealError(err: unknown): boolean {
  if (err == null) return false;
  if (typeof err === "string") return isLockStealMessage(err);
  return isLockStealMessage((err as { message?: unknown }).message);
}
